/*
 * Deprecated
 * Please use src/composables/table-helpers/useMemoDefaultColumnOrder.ts
 */

import { ref, watch } from "vue";
import { useCookies } from "@vueuse/integrations/useCookies";

export const useMemoColumnOrder = (
  key: string,
  defaultColumnOrder: string[],
) => {
  const cookies = useCookies();
  const columnOrderFromCookies = cookies.get(key);

  const columnOrder = ref(columnOrderFromCookies ?? defaultColumnOrder);

  const memoizeColumnOrder = () => {
    cookies.set(key, columnOrder.value);
  };

  watch(
    () => columnOrder.value,
    () => memoizeColumnOrder(),
  );

  return {
    columnOrder,
  };
};

export default {};
